// extracted by mini-css-extract-plugin
module.exports = {"modal":"PushNoteUserPermissionPrompt_modal__2jdBE","row":"PushNoteUserPermissionPrompt_row__1X33z","buttonRow":"PushNoteUserPermissionPrompt_buttonRow__Jp2dJ"};